module.exports = __webpack_public_path__ + "img/myvoco_votes_about_us_logo.1c3f35a8.jpg";